import { Stack } from "@mui/material";
import WarehouseLabelQueueFab from "./WarehouseLabelQueueFab";
import WarehouseShoppingListFab from "./WarehouseShoppingListFab";

// Both FABs render nothing when their buffer is empty (see each
// component), so this stack only ever shows what's actually in use - one,
// both, or neither. Owns the single fixed position both FABs used to hard-
// code individually, which would otherwise have them drawn on top of each
// other when both buffers have items.
export default function WarehouseQueueFabs() {
  return (
    <Stack
      spacing={2}
      alignItems="flex-end"
      sx={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <WarehouseShoppingListFab />
      <WarehouseLabelQueueFab />
    </Stack>
  );
}
